import { useQuery, UseQueryOptions } from "@tanstack/react-query";
import { nanoid } from "nanoid";
import { IOpponentAdd, IOpponents } from "utils/api.interfaces";
import axiosinterceptor from "../utils/api.interceptor";

export const fetchOpponents = (
  teamId: string | undefined
): Promise<IOpponents> =>
  // axiosinterceptor.get(`v1/Teams/${teamId}`).then<ITeam>((res) => res.data);

  axiosinterceptor
    .get(`/v1/FootballMatches/football/opponents/${teamId}`)
    .then<IOpponents>((res) => res.data);

export default function useOpponents(
  teamId: string | undefined,
  options?: Omit<
    UseQueryOptions<
      IOpponents,
      Error,
      IOpponents,
      ["opponent", string | undefined]
    >,
    "queryKey" | "queryFn"
  >
) {
  const queryOpponent = useQuery({
    queryKey: ["opponent", teamId],
    queryFn: () => fetchOpponents(teamId),
    enabled: !!teamId,
    ...options,
  });

  return {
    ...queryOpponent,
    dataOpponents: queryOpponent?.data,
    dataOpponentsIsLoading: queryOpponent?.isLoading,
  };
}
export const postOpponent = (opponent: IOpponentAdd): Promise<any> => {
  const opponentId = nanoid();
  return axiosinterceptor
    .post(`/v1/FootballMatches/football/opponents`, {
      ...opponent,
      id: opponentId,
    })
    .then((res) => {
      return opponentId;
    });
};
